import "./UserInfoTable.html";
import "./UserInfoTable.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { UserInfoTableComponentController } from "./UserInfoTableComponentController";

export class UserInfoTableComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            user: "<",
        };
        this.controller = UserInfoTableComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/UserInfoTable/UserInfoTable.html";
    }
}
